import React from 'react'
import { matchPath } from 'react-router'
import homeIcon from '@icons/home/red'
import classesIcon from '@icons/people/primary'
import statisticsIcon from '@icons/statistics/primary'
import tasksIcon from '@icons/computer/primary'

export const teacherTabs = (ability, { location }) => {
  const statisticsTab = (ability, location) => {
    const to = "/teachers/classes/statistics"
    const disabled = !ability.can('read', 'Statistic', 'trial') &&
                     !ability.can('read', 'Statistic', 'main') &&
                     !ability.can('read', 'Statistic', 'preparatory')

    let active = !!matchPath(location.pathname, { path: to, exact: true })

    active = active || !!matchPath(location.pathname, {
      path: "/teachers/classes/:id/statistics"
    })

    return { to, content: I18n.t('teachers.show.statistic'), icon: statisticsIcon, active, disabled }
  }

  const diplomasTab = (ability, location) => {
    const to = "/teachers/classes/diplomas"
    const disabled = !ability.can('read', 'Diplomas')

    let active = !!matchPath(location.pathname, { path: to, exact: true })

    active = active || !!matchPath(location.pathname, {
      path: "/teachers/classes/:id/diplomas"
    })

    return { to, content: I18n.t('awards.tab_title'), icon: homeIcon, active, disabled }
  }

  return [
    {
      to: "/teachers/home",
      icon: homeIcon,
      content: 'Home'
    },
    statisticsTab(ability, location),
  ]
}

export const parentTabs = (ability, { location }) => {
  const statisticsTab = (ability, location) => {
    const to = "/parents/statistics";
    const disabled = !ability.can('read', 'Statistic', 'trial') &&
                     !ability.can('read', 'Statistic', 'main') &&
                     !ability.can('read', 'Statistic', 'preparatory')

    let active = !!matchPath(location.pathname, { path: to, exact: true })
    return { to, content: I18n.t('teachers.show.statistic'), icon: statisticsIcon, active, disabled }
  }

  return [
    {
      to: "/parents/home",
      icon: homeIcon,
      content: ''
    }, {
      to: "/parents/children",
      content: I18n.t('layouts.parent.kids'),
      icon: classesIcon
    },
    statisticsTab(ability, location)
    // , {
    //   to: "/parents/children/diplomas",
    //   content: I18n.t('awards.tab_title'),
    //   disabled: !ability.can('read', 'Diplomas')
    // }
  ]
}
